import { useState } from 'react';
import { useQuery } from 'react-query';
/**
 * Componentes
 */
import { PageHelper } from 'Components/PageHelper';
import { DefaultTable } from 'Components/DefaultTable';
import { Container } from '../../Components/Container';
import { Information } from 'Components/Information';
import { tableHeader } from './table-header.js';
import { ModalConfirmDelete } from 'Components/ModalConfirmDelete';
import { deleteData, getDatasPaged } from 'services/datas-service';
import { PageLoaderList } from 'Components/PageLoader/List';

import { useAuthTenant } from 'store/auth';
import { useSelector } from 'react-redux';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { NoData } from 'Components/NoData';
import { Pagination, Stack } from '@mui/material';

export const Data = () => {
  const selectedTenant = useSelector(useAuthTenant);
  const SwalReact = withReactContent(Swal);
  const [open, setOpen] = useState(false);
  const [reFetch, setRefetch] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [page, setPage] = useState(1);
  const {
    isLoading,
    error,
    data: pagedDatas,
  } = useQuery(['getData', reFetch, page], async () => {
    if (selectedTenant.slug === undefined) return [];
    const result = await getDatasPaged(selectedTenant.slug, page, 15);
    if (result?.data.data.length > 0) {
      return result?.data;
    }
    return {
      data: [],
      page,
      totalPages: 0,
    };
  });

  const onDelete = item => {
    setItemToDelete(item);
    setOpen(true);
  };

  const onClose = () => {
    setItemToDelete(null);
    setOpen(false);
  };

  const onConfirm = async () => {
    try {
      const result = await deleteData(itemToDelete?._id);
      if (result.status === 204) {
        onClose();
        setRefetch(!reFetch);
        SwalReact.fire({
          title: 'Sucesso!',
          text: 'Tipo de Dado removido com sucesso',
          icon: 'success',
        });
      } else {
        throw new Error('Ocorreu um erro ao tentar remover os Dados!');
      }
    } catch (error) {
      SwalReact.fire({
        title: 'Erro!',
        text: error.response.data.message ?? error.message,
        icon: 'error',
      });
    }
  };

  return (
    <Container title="Tipos de dados" breadcrumb="Mapeamento / Tipo de dados" showButtonAdd linkPage="/data" data-tour="page-title">
      <div data-tour="info-card">
      <Information
        title={'Tipos de dados'}
        description={`Aqui pode-se obter informações sobre os tipos de dados cadastrados no sistema.`}
        style={{
          marginTop: '24px',
        }}
      />
      </div>
      {isLoading && <PageLoaderList></PageLoaderList>}
      {error && <div>Ocorreu um erro ...</div>}
      {!isLoading && !error && pagedDatas.data.length === 0 && (
        <NoData description={'Não há tipos de dados para exibir'} />
      )}
      {!isLoading && !error && pagedDatas.data.length > 0 && (
        <div className="container">
          <div data-tour="table">
          <DefaultTable rows={tableHeader} cells={pagedDatas.data} onClickDelete={onDelete} link="data" />
          </div>
          <div data-tour="pagination">
          <Stack sx={{ justifyContent: 'center', flexDirection: 'row', marginTop: '16px' }}>
            <Pagination
              count={pagedDatas.totalPages}
              onChange={(_, selectedPage) => {
                setPage(selectedPage);
              }}
              color="primary"
              page={page}
              showFirstButton
              showLastButton
            />
          </Stack>
          </div>
          <ModalConfirmDelete
            description={
              <>
                Tem certeza que deseja excluir <strong>{` ${itemToDelete?.name} `}</strong> como tipo de dado?
              </>
            }
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
          />
        </div>
      )}
      <PageHelper steps={tourSteps} tourKey="data-list" />
    </Container>
  );
};

const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo à página de Tipos de Dados! Aqui você gerencia as categorias de dados pessoais processados pela sua organização.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: '[data-tour="page-title"] button',
    content: 'Use este botão para adicionar um novo tipo de dado ao sistema.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="info-card"]',
    content: 'Os tipos de dados ajudam a classificar informações pessoais (ex: CPF, email, endereço) facilitando o mapeamento e conformidade com LGPD.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="table"]',
    content: 'Esta tabela exibe todos os tipos de dados cadastrados. Você pode visualizar, editar ou excluir cada tipo.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="pagination"]',
    content: 'Use a paginação para navegar entre as páginas quando houver muitos tipos de dados cadastrados.',
    disableScrolling: false,
  },
  {
    target: 'body',
    content: 'Tour concluído! Agora você conhece todas as funcionalidades da página de Tipos de Dados. Gerencie suas categorias de dados com facilidade.',
    disableScrolling: true,
    placement: 'center',
  },
];
